import CloseConfirmationModal from './CloseConfirmationModal'
import useCloseConfirmationModal from './useCloseConfirmationModal'

export default CloseConfirmationModal
export { useCloseConfirmationModal }
